/**
 * PWA service worker (vite-plugin-pwa / Workbox): precaches the app shell so repeat
 * opens are instant and the app starts offline. A new release activates on the next
 * navigation; open screens pick it up without interrupting a tap.
 */
export function registerServiceWorker(): void {
  if (!('serviceWorker' in navigator) || import.meta.env.DEV) return;
  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({
      immediate: true,
      onRegisteredSW(_url, reg) {
        if (reg) setInterval(() => void reg.update(), 30 * 60_000);
      },
    });
  });
}
